import { render, staticRenderFns } from "./ColoredBooleanField.vue?vue&type=template&id=0d874cac&scoped=true&"
import script from "./ColoredBooleanField.vue?vue&type=script&lang=ts&"
export * from "./ColoredBooleanField.vue?vue&type=script&lang=ts&"
import style0 from "./ColoredBooleanField.vue?vue&type=style&index=0&id=0d874cac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d874cac",
  null
  
)

export default component.exports